'use strict';

export default (state = false, action) => {
  if (action.type && action.type === 'PREQUAL_ERROR') {
    return action.data;
  }
  return state;
};
